import React, {Component} from "react"
import PropTypes from "prop-types"

import {SelectDropdown} from "~/components"
import BlobDownload from "~/utils/BlobDownload"

export default class DownloadSelect extends Component {
  constructor(props) {
    super(props)

    this.state = {
      loading: false
    }
  }

  selectHandler = option => {
    if (this.state.loading) return

    const endpointWithParams = `${this.props.endpoint}?${
      this.props.endpointParamName
    }=${option.id}`

    if (
      this.downloader &&
      this.downloader.isLoaded() &&
      endpointWithParams === this.downloader.endpoint
    ) {
      this.downloader.getFile()
    } else {
      let filename = option.filename
      if (!filename) {
        filename = this.props.endpoint
          .replace(/\/|(_csv)/g, "")
          .replace(".csv", `${option.id}.csv`)
      }

      if (this.downloader) this.downloader.freeResources()
      this.downloader = new BlobDownload(endpointWithParams, filename)

      this.setState({loading: true})

      this.downloader.loadFile().then(() => this.setState({loading: false}))
    }
  }

  componentWillUmount() {
    if (this.downloader) this.downloader.freeResources()
  }

  render = () => (
    <div className="sh-download-select">
      <SelectDropdown
        name="csv_download"
        value={this.props.label}
        options={this.props.options}
        onSelect={this.selectHandler}
      />
    </div>
  )
}

DownloadSelect.propTypes = {
  endpoint: PropTypes.string.isRequired,
  endpointParamName: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  options: PropTypes.array.isRequired
}



// WEBPACK FOOTER //
// ./src/components/decorators/DownloadSelect.js